<template>
  <base-modal
    v-if="visible"
    title="Patients manuellement exclus du programme"
    @close="$emit('close')"
  >
    <base-container class="mt-4 space-y-6">
      <ProgramExcludedConsumerRow
        v-for="consumer in consumers"
        :key="consumer.key"
        :program="program"
        :consumer="consumer"
        @unmasked="$emit('unmasked', $event)"
      />
    </base-container>
  </base-modal>
</template>

<script lang="ts" setup>
import BaseModal from '@/core/components/base/BaseModal.vue';
import BaseContainer from '@/core/components/base/BaseContainer.vue';
import ProgramExcludedConsumerRow from '@/program/components/program-consumers/ProgramExcludedConsumerRow.vue';
import {Program, SupportProgramPatient} from "@/program/interfaces/Program";

defineEmits(['close', 'unmasked']);
defineProps<{
    consumers: SupportProgramPatient[],
    visible: boolean,
    program: Program
}>();
</script>
